import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { gsap } from "gsap";    

@Component({
  selector: 'app-tab-view',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './tab-view.component.html',
  styleUrl: './tab-view.component.scss'
})
export class TabViewComponent {
  tabContent:any;
  @Input() Theme:any;
  @ViewChild('content') content!: ElementRef;
  constructor() {}

  ngOnInit() {
  }

  openContentTabsView(){
    this.tabContent = gsap.timeline({ repeat: 0, yoyo: true, paused: true});
    this.tabContent.fromTo(this.content.nativeElement.children[0].children[0].children[0].children, 0.3,{opacity:0, x:15},{opacity:1,x:0,stagger:0.19});
    this.tabContent.play();
  }
}
